/**
 * Debajo del título de Público (DISENO §2): hasta qué día trae ventas la base en uso, en rojo si pasó el umbral de
 * antigüedad, y el link para subir una nueva. Es del equipo: la base de ventas no la ve una persona de un cliente.
 */

import { Link } from "react-router-dom";
import { Upload } from "lucide-react";
import type { EstadoBase } from "../types";
import { R_SUBIR_BASE, textoAntiguedad } from "../logic/base";

export function LineaBase({ estado }: { estado: EstadoBase }) {
  const tono = !estado.enUso ? "bg-amber-50 text-amber-800" : estado.vieja ? "bg-red-50 text-red-700" : "bg-slate-100 text-slate-600";
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2 text-sm" data-testid="estado-base">
      <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${tono}`}>
        {estado.enUso ? textoAntiguedad(estado.enUso.hasta, estado.dias) : "Todavía no hay una base de ventas"}
        {estado.vieja && <span className="sr-only"> (base desactualizada)</span>}
      </span>
      <Link to={R_SUBIR_BASE} className="min-h-[44px] inline-flex items-center gap-1.5 font-semibold text-violet-700 hover:text-violet-900">
        <Upload size={14} aria-hidden="true" /> Subir base de datos
      </Link>
    </div>
  );
}
